import { render, staticRenderFns } from "./InitiateDischarge.vue?vue&type=template&id=21df4cbe&"
import script from "./InitiateDischarge.vue?vue&type=script&lang=js&"
export * from "./InitiateDischarge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports